/**
 * Configuração única do Google Maps para todo o app.
 * useJsApiLoader não pode ser chamado com opções diferentes entre rotas —
 * senão quebra ao navegar entre /mapa e /analise-territorial-frequencia.
 */
export const GOOGLE_MAPS_LIBRARIES = [];

export function getGoogleMapsLoaderOptions(apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '') {
  return {
    id: 'reuniao-google-maps',
    googleMapsApiKey: apiKey,
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: 'pt-BR',
  };
}
